import * as React from 'react'

const DeleteIcon = props => (
  <svg
    width="126"
    height="126"
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M110.25 31.3945C92.7675 29.662 75.18 28.7695 57.645 28.7695C47.25 28.7695 36.855 29.2945 26.46 30.3445L15.75 31.3945"
      fill="black"
      fill-opacity="0.56"
    />
    <path
      d="M110.25 31.3945C92.7675 29.662 75.18 28.7695 57.645 28.7695C47.25 28.7695 36.855 29.2945 26.46 30.3445L15.75 31.3945"
      stroke="#004360"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M44.625 26.0925L45.78 19.215C46.62 14.2275 47.25 10.5 56.1225 10.5H69.8775C78.75 10.5 79.4325 14.4375 80.22 19.2675L81.375 26.0925"
      stroke="#004360"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M98.9641 47.9844L95.5516 100.852C94.9741 109.094 94.5016 115.499 79.8541 115.499H46.1491C31.5016 115.499 31.0291 109.094 30.4516 100.852L27.0391 47.9844"
      stroke="#004360"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.2344 86.625H71.7169"
      stroke="#004360"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.875 65.625H76.125"
      stroke="#004360"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default DeleteIcon
